export const RESIZE_DEBOUNCE_THRESHOLD = 100;
